/* eslint-disable no-underscore-dangle */
import { createStore, applyMiddleware, compose } from 'redux';
import { createLogger } from 'redux-logger';
import promiseMiddleware from 'redux-promise-middleware';
import reducers from './Reducers/index';

const logger = createLogger({});
const localCompose = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1' ? applyMiddleware(logger, promiseMiddleware) : applyMiddleware(promiseMiddleware);

const store = createStore(
  reducers,
  compose(
    // applyMiddleware(promiseMiddleware),
    localCompose,
  ),
);

export default store;
